import script from "./SectionFilialiGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionFilialiGroup.vue?vue&type=script&setup=true&lang=js"

import "./SectionFilialiGroup.vue?vue&type=style&index=0&id=0e1eb664&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1eb664"]])

export default __exports__